import { errorPlayerContainerNotCreated } from './errors';
export const playerPlay = (container) => {
    if (!container) {
        throw errorPlayerContainerNotCreated;
    }
    const player = container.getAny();
    player.play();
};
